import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Landing from '@/pages/Landing';
import Auth from '@/pages/Auth';
import PendingApproval from '@/pages/PendingApproval';
import PlayerDashboard from '@/pages/PlayerDashboard';
import ScoutDashboard from '@/pages/ScoutDashboard';
import CoachDashboard from '@/pages/CoachDashboard';
import SchoolDashboard from '@/pages/SchoolDashboard';
import AdminDashboard from '@/pages/AdminDashboard';
import UnionDashboard from '@/pages/UnionDashboard';
import PerformanceHub from '@/pages/PerformanceHub';
import Playbook from '@/pages/Playbook';
import PlayerProfile from '@/pages/PlayerProfile';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import TermsOfService from '@/pages/TermsOfService';
import MessagesPage from '@/pages/MessagesPage';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';
import VerifyLanding from '@/pages/VerifyLanding';
import About from '@/pages/public/About';
import Features from '@/pages/public/Features';
import ForPlayers from '@/pages/public/ForPlayers';
import ForSchools from '@/pages/public/ForSchools';
import ForScouts from '@/pages/public/ForScouts';
import Pricing from '@/pages/public/Pricing';
import SecurityCompliance from '@/pages/public/SecurityCompliance';
import Contact from '@/pages/public/Contact';
import { AuthProvider } from '@/context/AuthContext';
import ProtectedRoute from '@/components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/pending" element={<PendingApproval />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify/:type/:token" element={<VerifyLanding />} />
          <Route
            path="/playbook"
            element={
              <ProtectedRoute>
                <Playbook />
              </ProtectedRoute>
            }
          />
          <Route path="/about" element={<About />} />
          <Route path="/features" element={<Features />} />
          <Route path="/for-players" element={<ForPlayers />} />
          <Route path="/for-schools" element={<ForSchools />} />
          <Route path="/for-scouts" element={<ForScouts />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/security-compliance" element={<SecurityCompliance />} />
          <Route path="/contact" element={<Contact />} />
          <Route
            path="/player/dashboard"
            element={
              <ProtectedRoute requiredRole="player">
                <PlayerDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/scout/dashboard"
            element={
              <ProtectedRoute requiredRole="scout">
                <ScoutDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/coach/dashboard"
            element={
              <ProtectedRoute requiredRole="coach">
                <CoachDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/school/dashboard"
            element={
              <ProtectedRoute requiredRole="school_club">
                <SchoolDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/union/dashboard"
            element={
              <ProtectedRoute requiredRole="union">
                <UnionDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/performance"
            element={
              <ProtectedRoute>
                <PerformanceHub />
              </ProtectedRoute>
            }
          />
          <Route path="/players/:playerId" element={<PlayerProfile />} />
          <Route
            path="/messages"
            element={
              <ProtectedRoute>
                <MessagesPage />
              </ProtectedRoute>
            }
          />
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
